var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-wrapper"},[_c('Head',{attrs:{"title":_vm.$tc('header.back')}}),_c('Empty',{attrs:{"emptydata":_vm.emptydata}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }